import { inject } from '@angular/core';

import { TOASTER_STATUS } from '../components/toaster/toaster.types';
import { ToasterStore, type ToastInput } from '../services/toaster.store';

export type ShowToastOptions = Omit<ToastInput, 'status'>;

export function useToaster() {
    const store = inject(ToasterStore);

    return {
        toasts: store.toasts,
        success: (options: ShowToastOptions): string | undefined =>
            store.add({ status: TOASTER_STATUS.SUCCESS, ...options }),
        error: (options: ShowToastOptions): string | undefined =>
            store.add({ status: TOASTER_STATUS.ERROR, ...options }),
        info: (options: ShowToastOptions): string | undefined => store.add({ status: TOASTER_STATUS.INFO, ...options }),
        dismiss: (id: string): void => store.dismiss(id),
        clear: (): void => store.clear(),
    };
}
